<template>
  <div>
    <CTabs class="border border-1 rounded">
      <CTab active>
        <template slot="title">
          {{ $t("role.profile.tab_infos.title") }}</template
        >
        <CRow>
          <CCol md="12">
            <ProfileInfoNew :roleData="role" v-if="!loading" />
            <CSpinner color="primary" v-else />
          </CCol>
        </CRow>
      </CTab>

      <CTab>
        <template slot="title">
          {{ $t("role.profile.tab_images.title") }}
        </template>
        <CRow>
          <CCol md="12">
            <ProfileImages />
          </CCol>
        </CRow>
      </CTab>
      <CTab>
        <template slot="title"> Transparenz </template>
        <CRow>
          <CCol md="12">
            <ProfileTransparency
              v-if="profileData"
              :profileData="profileData"
            />
          </CCol>
        </CRow>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import { apiGet } from "../../../helpers/apiHelper";
import ProfileInfoNew from "./ProfileInfoNew";
import ProfileLogo from "./ProfileLogo";
import ProfileImages from "./ProfileImages";
import ProfileTransparency from "./ProfileTransparency";

export default {
  name: "ProfileData",
  data() {
    return {
      loading: true,
      activeTab: 0,
      wallet: null,
      role: null,
      profileData: null,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      const response = await apiGet(
        "auth_frole",
        [],
        this.$store.state.role.id
      );
      if (response && response.data) {
        this.loading = false;
        this.role = response.data;
        this.profileData = response.data;
      }
    },
  },
  components: {
    ProfileImages,
    ProfileInfoNew,
    ProfileLogo,
    ProfileTransparency,
  },
};
</script>
